import styled from "styled-components";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "components/shared/Modal/Modal";
import { colors } from "utils";

export const OrchestratorTimeoutModal = ({ open, onRestart, isRestarting }) => {
  return (
    <Modal open={open}>
      <Title>Oh no! Let's try that again.</Title>
      <Body>
        We hit a little bump in the road, but the <strong>OKO Team</strong> has
        been notified and is looking into it. Technology can be tricky sometimes,
        but we're ready to get you back into the conversation.
      </Body>
      <StyledButton onClick={onRestart} disabled={isRestarting}>
        {isRestarting ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin /> Restarting...
          </>
        ) : (
          "Restart Session"
        )}
      </StyledButton>
    </Modal>
  );
};

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
`;

const Body = styled.p`
  font-size: 16px;
  text-align: center;
  margin-bottom: 24px;
  color: #333;
`;

const StyledButton = styled(Button)`
  background-color: ${colors.pink500};
  border: none;
  border-radius: 20px;
  font-size: 14px;
  padding: 10px 24px;
  align-self: center;
  width: fit-content;

  &:hover,
  &:focus,
  &:active {
    background-color: ${colors.pink500};
    filter: brightness(0.9);
  }

  &:disabled {
    background-color: ${colors.pink500};
    opacity: 0.7;
  }
`;
